const FilterValueRenderers = {
  type: (_value, title) => title
};
export default FilterValueRenderers;
